document.addEventListener("DOMContentLoaded", () => {
  const swatchHoverItems = document.querySelectorAll(".swatch_hover[data-variant-image]");

  swatchHoverItems.forEach(item => {
    item.addEventListener("mouseover", () => {
      const variantImage = item.getAttribute('data-variant-image');
      const gridItem = item.closest(".grid__item");

      if (gridItem) {
        const img = gridItem.querySelector(".grid__image-ratio img");

        if (img) {
          img.src = variantImage;
          img.srcset = variantImage;
        }
      }
    });
  });
});
